export default __webpack_public_path__ + "static/media/nft_card_preview.da45cbcd.png";